import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import { WithPenNameStoryListProps, PenNameStoryListProps } from './interface'

export function withPenNameStoryList(
  Component: React.FC<PenNameStoryListProps>
) {
  function WithPenNameStoryList({
    penName,
    ...props
  }: WithPenNameStoryListProps) {
    const [isShowDetail, setIsShowDetail] = useState(false)
    const { query } = useRouter()

    function toggleShowDetail() {
      setIsShowDetail((prev: boolean) => !prev)
    }

    useEffect(() => {
      setIsShowDetail(penName === query.text?.toString())
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const newProps = {
      ...props,
      penName,
      isShowDetail,
      toggleShowDetail,
    }

    return <Component {...newProps} />
  }
  return WithPenNameStoryList
}
